import { CopyOutlined } from "@ant-design/icons";
import { Button, message, Space, Tabs } from "antd";
import type React from "react";
import type { DisplayFilter } from "../../types";

export interface EventOccasionsFilterTabsProps {
	activeTab: DisplayFilter;
	onTabChange: (tab: DisplayFilter) => void;
	eventListUrl?: string;
	primaryColor?: string;
	showCopyButton?: boolean;
}

export const EventOccasionsFilterTabs: React.FC<
	EventOccasionsFilterTabsProps
> = ({
	activeTab,
	onTabChange,
	eventListUrl,
	primaryColor = "#99CA29",
	showCopyButton = true,
}) => {
	const handleCopyUrl = async () => {
		if (!eventListUrl) {
			message.warning("イベント一覧URLが設定されていません");
			return;
		}

		try {
			await navigator.clipboard.writeText(eventListUrl);
			message.success("URLをクリップボードにコピーしました");
		} catch (error) {
			const textArea = document.createElement("textarea");
			textArea.value = eventListUrl;
			textArea.className = "fixed opacity-0";
			document.body.appendChild(textArea);
			textArea.select();
			try {
				document.execCommand("copy");
				message.success("URLをクリップボードにコピーしました");
			} catch (_err) {
				message.error("URLのコピーに失敗しました");
			}
			document.body.removeChild(textArea);
		}
	};

	const tabItems = [
		{
			key: "displayed",
			label: "表示",
		},
		{
			key: "hidden",
			label: "非表示",
		},
	];

	return (
		<div className="flex justify-between items-center">
			<Tabs
				activeKey={activeTab}
				onChange={(key) => onTabChange(key as "displayed" | "hidden")}
				items={tabItems}
			/>
			{showCopyButton && (
				<Space>
					<span className="mr-2">イベント一覧URL</span>
					<Button icon={<CopyOutlined />} onClick={handleCopyUrl} size="small">
						コピー
					</Button>
				</Space>
			)}
		</div>
	);
};
